/**
 * Implements connect wallet modal
 */
import { useState } from 'react';
import MetamaskIcon from './images/metamask.svg';
import WalletConnect from './images/wallet_connect.svg';
import Unstoppable from './images/unsoppable/default-small.svg';
import Ledger from './images/ledger-square.svg';
import Coinbase from './images/coinbase.svg';
// import TronLink from './images/tronLink.png';
import MultiversX from './images/multiversX.png';
import Card from './Card';
// import { useTronlink } from '../../../hooks/useTronLink';
import { connect } from 'react-redux';
import { actionCreateNotification } from '../../../actions/notifications';
import { useConnect } from 'wagmi';
import './styles.scss';
import useMobileDetect from '../../../pages/MainPage/useMobileDetect';
import {
  SetLastConnectedWallet,
  WalletsType,
} from '../../ConnectedWallet/wallets.ls';
import { useWallet } from '../../../wallet/walletContext';

interface props {
  onCancel: () => void;
  notify: (input: any) => void;
}

const onMetamaskDownload = () => {
  window.open('https://metamask.io/download/', '_blank');
};

const ConnectModal = ({ onCancel, notify }: props) => {
  const [lock, setLock] = useState(false);
  const { isMobile } = useMobileDetect();
  const { connectors } = useConnect();
  const { onConnect } = useWallet();

  return (
    <div className='connect_modal'>
      <div className='connect_modal__header'>
        <div className='connect_modal__header__caption'>Connect Wallet</div>
        <div className='connect_modal__header__close' onClick={onCancel} />
      </div>
      <div className='connect_modal__contents'>
        <p className='connect_modal__contents__disclaimer'>
          Use walletconnect for log in or your browser in the mobile wallet
        </p>
        {connectors.map((connector) => {
          if (connector.name == 'WalletConnect') {
            if (connector.ready) {
              return (
                <Card
                  key={connector.id}
                  lock={lock}
                  title='WalletConnect'
                  icon={WalletConnect}
                  onClick={() => {
                    SetLastConnectedWallet(WalletsType.Other);
                    onConnect(connector, notify, onCancel);
                  }}
                />
              );
            }
          }
          if (connector.name == 'MetaMask') {
            if (connector.ready) {
              return (
                <Card
                  key={connector.id}
                  lock={lock}
                  title='Connect browser wallet'
                  icon={MetamaskIcon}
                  onClick={() => {
                    SetLastConnectedWallet(WalletsType.MetaMask);
                    onConnect(connector, notify, onCancel);
                  }}
                />
              );
            } else {
              return (
                <Card
                  key={connector.id}
                  lock={lock}
                  title='Install MetaMask'
                  icon={MetamaskIcon}
                  onClick={onMetamaskDownload}
                />
              );
            }
          }

          if (connector.name == 'UnstoppableDomains') {
            return (
              <Card
                key={connector.id}
                lock={lock}
                title='UnstoppableDomains'
                icon={Unstoppable}
                onClick={() => {
                  SetLastConnectedWallet(WalletsType.Other);
                  onConnect(connector, notify, onCancel);
                }}
              />
            );
          }

          if (connector.name == 'Ledger') {
            if (connector.ready) {
              return (
                <Card
                  key={connector.id}
                  lock={lock}
                  title='Connect with Ledger'
                  icon={Ledger}
                  additinalClass={'ledger-icon'}
                  onClick={() => {
                    SetLastConnectedWallet(WalletsType.Other);
                    onConnect(connector, notify, onCancel);
                  }}
                />
              );
            }
          }

          if (connector.name == 'Coinbase Wallet') {
            if (connector.ready) {
              return (
                <Card
                  key={connector.id}
                  lock={lock}
                  title='Connect with Coinbase Wallet'
                  icon={Coinbase}
                  onClick={() => {
                    SetLastConnectedWallet(WalletsType.Other);
                    onConnect(connector, notify, onCancel);
                  }}
                />
              );
            }
          }

          if (connector.name == 'MultiversX Wallet') {
            if (connector.ready) {
              return (
                <Card
                  key={connector.id}
                  lock={lock}
                  title='Connect with MultiversX'
                  icon={MultiversX}
                  onClick={() => {
                    if (isMobile) {
                      window.location.href = 'https://xportal.com/';
                    } else {
                      SetLastConnectedWallet(WalletsType.MultiversX);
                      onConnect(connector, notify, onCancel);
                    }
                  }}
                />
              );
            }
          }
        })}

        {/* <Card lock={lock} title="TronLink" icon={TronLink} onClick={onConnectTronLink} additinalClass={'tronLink-icon'} /> */}
        {/* <Card lock={lock} title="Maiar wallet" icon={Unstoppable} onClick={onConnectMaiarWallet} /> */}
      </div>
    </div>
  );
};

export default connect(null, {
  notify: actionCreateNotification,
})(ConnectModal);
